<template>
  <div>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <v-dialog v-model="basariliDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="text-h5">Rezervasyon Tamamlandı</v-card-title>
        <v-card-text>
          <p>Rezervasyon başarılı!</p>
          <p><strong>PNR No:</strong> {{ this.pnr }}</p>
          <v-btn @click="voucherDownload()" color="primary">
              <v-icon right dark>playlist_add_check</v-icon>
              Voucher
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="basariliDialog = false">Kapat</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card color="grey lighten-5">
      <v-layout row wrap>
        <v-flex xs12 sm12>

          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ 'Paket Tur Rezervasyon' }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="e1 = 2">
              <v-icon right dark>undo</v-icon>
              Listeye Dön
            </v-btn>
            <v-btn @click="rezervasyonTamamla()" color="primary">
              <v-icon right dark>playlist_add_check</v-icon>
              Tamamla
            </v-btn>
          </v-toolbar>
        </v-flex>

      </v-layout>
    </v-card>
    <v-card color="grey lighten-5 pa-4">
      <v-layout row wrap>
        <v-flex xs12 sm12 md8>

          <v-stepper v-model="e1">
            <v-stepper-header>
              <v-stepper-step :complete="e1 > 1" step="1">Kişiler</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="e1 > 2" step="2">Ek Masraflar</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="3">Ödeme Bilgileri</v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content step="1">
                <Turrezervasyonkisiler @update-odalar="updateOdalar" :SelectedOdaTipleri="SelectedOdaTipleri" />
                <v-card>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="kisileriKaydet()">
                      Devam
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <Turrezervasyonekhizmetler :kisiler="kisiler" :eklenenEkHizmetler="eklenenEkHizmetler"
                @update-eklenen-ek-hizmetler="updateEklenenEkHizmetler" :ekhizmetler="ekhizmetler" :altGrup="altGrup"/>
                <v-btn color="primary" @click="e1 = 3">
                  Devam
                </v-btn>

                <v-btn color="secondary" @click="e1 = 1">
                  Geri
                </v-btn>
              </v-stepper-content>

              <v-stepper-content step="3">
                <Turrezervasyonodemeler :carikod="cariKod" :odemeData="odemeData" @update-odeme-data="updateOdemeData" />
                <v-btn color="primary" @click="e1 = 2">
                  Geri
                </v-btn>

                <v-btn flat>Cancel</v-btn>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-flex>
        <v-flex xs12 sm12 md4>
          <Turrezdetay :paket="paket" :altGrup="altGrup" :fiyatlar="fiyatlar"/>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>
<script>
import tarihcomp from '../customcomp/tarihim.vue'
import kisitip from "@/components/app/coper/comp/kisitip.vue";
import helpers from "@/components/app/customcomp/helpers.js"
import tool from '../coper/tools';
import auth from '../../../api/auth'
import tahsilatdialog from "./tahsilatdialog.vue"
import Turrezervasyonkisiler from './rezervasyon/turrezervasyonkisiler.vue';
import Turrezdetay from './rezervasyon/turrezdetay.vue';
import Turrezervasyonekhizmetler from './rezervasyon/turrezervasyonekhizmetler.vue';
import Turrezervasyonodemeler from './rezervasyon/turrezervasyonodemeler.vue';
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
export default {
  data() {
    return {
      e1: 0,
      SelectedOdaTipleri: [],
      text1:"",
      snackbar:false,
      kisiler: [],
      ekhizmetler: [],
      paket: null,
      fiyatGrubu: null,
      altGrup: null,
      cariKod:{
        kod:""
      },
      fiyatlar: {
        Yetiskin: {
          sayi: 0,
          fiyat: 0
        },
        Cocuk: {
          sayi: 0,
          fiyat: 0
        },
        Bebek: {
          sayi: 0,
          fiyat: 0
        },
        EkHizmetler: {
          sayi: 0,
          fiyat: 0
        }
      },
      eklenenEkHizmetler: [],
      odemeData: [],
      pnr: 0,
      basariliDialog: false
    }
  },
  mounted() {
    this.PaketLoad(this.$route.query.paketid, this.$route.query.fiyatGrubuId, this.$route.query.altGrupId)
  },
  watch: {
    SelectedOdaTipleri: function () {
      this.fiyatHesapla();
    },
    eklenenEkHizmetler: {
    deep: true,
    handler(newVal, oldVal) {
      this.fiyatHesapla();

    },
  },
  },
  components: {
    tarihcomp,
    kisitip,
    tahsilatdialog,
    Turrezervasyonkisiler,
    Turrezdetay,
    Turrezervasyonekhizmetler,
    Turrezervasyonodemeler,
    snackbarcomp
  },
  methods: {
    PaketLoad(paketId, fiyatGrubuId, altGrupId) {
      let params = {
        Id: paketId,
        tumSirketler: false,
        sayfaAdi: null,
      };

      tool.http_post(this, "PaketLoad", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.paket = response.body.data;
            if (response.body.data.Program.FiyatGruplari.length > 0) {
              this.fiyatGrubu = response.body.data.Program.FiyatGruplari.filter(x => x.FiyatGrubu.id === fiyatGrubuId)[0];
              if (this.fiyatGrubu) {
                this.altGrup = this.fiyatGrubu.AltGruplar.filter(x => x.AltGrup.id === altGrupId)[0];
                this.getPaketEkHizmetler(this.altGrup.SatisFiyat.ParaBirimi)
              }
            }
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
        }
      );
    },
    getPaketEkHizmetler(paraBirimi) {
      let params = {
        Ara: this.searchara,
        ParaBirimi: paraBirimi
      };
      tool.http_post(this, "PaketEkHizmetList", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.ekhizmetler = response.body.data;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
    rezervasyonTamamla() {
      if(this.cariKod.kod === ""){
        this.snackbar = true;
        this.text1 = "Lütfen Cari Seçiniz."
        return;
      }
      var kisiler = [];
      var odalar = [];
      this.SelectedOdaTipleri.forEach(obj => {
        var odatipi = {
          Kod:obj.Kod,
          Yetiskin:obj.Yetiskin,
          Cocuk1:obj.Cocuk1,
          Cocuk2:obj.Cocuk2,
          KisiTc:[]
        };
        obj.formlar.yetiskin.forEach(x => {
          var dogumyili = new Date(x.DogumTarihi);
          var yas = helpers.getYear() - dogumyili.getFullYear();
          kisiler.push({
            Id: x.Id,
            KisiTip: x.KisiTip,
            Yas: yas,
            ProfilId: x.ProfilId,
            SicilId: x.SicilId,
            TcKimlikNo: x.TcKimlikNo,
            Sira: x.Sira ,
            UyeNo: x.UyeNo,
            LastName: x.Soyad,
            FirstName: x.Ad,
            AdSoyad: x.Ad + ' ' + x.Soyad,
            Adres: x.Adres,
            DogumTarihi: x.DogumTarihi,
            Cinsiyet: x.Cinsiyet,
            Telefon1: x.Telefon1,
            Gsm: x.Gsm,
            EMail: x.EMail,
            Isim:x.Ad,
            Soyisim:x.Soyad
          })
          odatipi.KisiTc.push(x.TcKimlikNo);
        });
        obj.formlar.cocuk.forEach(x => {
          var dogumyili = new Date(x.DogumTarihi);
          var yas = helpers.getYear() - dogumyili.getFullYear();
          kisiler.push({
            Id: x.Id,
          KisiTip: x.KisiTip,
          Yas: yas,
          ProfilId: x.ProfilId,
          SicilId: x.SicilId,
          TcKimlikNo: x.TcKimlikNo,
          Sira: x.Sira ,
          UyeNo: x.UyeNo,
          LastName: x.Soyad,
          FirstName: x.Ad,
          AdSoyad: x.Ad + ' ' + x.Soyad,
          Adres: x.Adres,
          DogumTarihi: x.DogumTarihi,
          Cinsiyet: x.Cinsiyet,
          Telefon1: x.Telefon1,
          Gsm: x.Gsm,
          EMail: x.EMail,
          Isim:x.Ad,
          Soyisim:x.Soyad
          });
          odatipi.KisiTc.push(x.TcKimlikNo);
        });
        obj.formlar.bebek.forEach(x => {
          var dogumyili = new Date(x.DogumTarihi);
          var yas = helpers.getYear() - dogumyili.getFullYear();
          kisiler.push({
          Id: x.Id,
          KisiTip: x.KisiTip,
          Yas: yas,
          ProfilId: x.ProfilId,
          SicilId: x.SicilId,
          TcKimlikNo: x.TcKimlikNo,
          Sira: x.Sira ,
          UyeNo: x.UyeNo,
          LastName: x.Soyad,
          FirstName: x.Ad,
          AdSoyad: x.Ad + ' ' + x.Soyad,
          Adres: x.Adres,
          DogumTarihi: x.DogumTarihi,
          Cinsiyet: x.Cinsiyet,
          Telefon1: x.Telefon1,
          Gsm: x.Gsm,
          EMail: x.EMail,
          Isim:x.Ad,
          Soyisim:x.Soyad
          });
          odatipi.KisiTc.push(x.TcKimlikNo);
        })
        odalar.push(odatipi);
      });
      var params = {
        PaketId: this.$route.query.paketid,
        FiyatGrubuId: this.$route.query.fiyatGrubuId,
        AltGrupId: this.$route.query.altGrupId,
        AcenteKodu: "DENEME",
        Kisiler: kisiler,
        Odalar: odalar,
        EkHizmetler: this.eklenenEkHizmetler,
        Odemeler:this.odemeData,
        CariKod:this.cariKod.kod
      }
      tool.http_post(this, "PaketRezervasyon", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.pnr = response.body.RezervasyonResponse.rezervasyon.pNR_No
            this.basariliDialog = true;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
        }
      );
    },
    fiyatHesapla() {
      var fiyatlar = {
        Yetiskin: {
          sayi: 0,
          fiyat: 0
        },
        Cocuk: {
          sayi: 0,
          fiyat: 0
        },
        Bebek: {
          sayi: 0,
          fiyat: 0
        },
        EkHizmetler: {
          sayi: 0,
          fiyat: 0
        }
      }
      this.SelectedOdaTipleri.forEach(oda => {
        var satisFiyatlar = this.altGrup.SatisFiyat;
        switch (oda.Yetiskin) {
          case 1:
            fiyatlar.Yetiskin.sayi += 1;
            fiyatlar.Yetiskin.fiyat += satisFiyatlar.TekKisiFiyati + satisFiyatlar.SingleFarki;
            break;
          case 2:
            fiyatlar.Yetiskin.sayi += 2;
            fiyatlar.Yetiskin.fiyat += satisFiyatlar.TekKisiFiyati * 2;
            break;
          case 3:
            fiyatlar.Yetiskin.sayi += 3;
            fiyatlar.Yetiskin.fiyat += satisFiyatlar.TekKisiFiyati * 2 + satisFiyatlar.UcuncuKisiFiyati;
            break;
          default:
            break;
        }
        fiyatlar.Cocuk.sayi += oda.Cocuk1;
        fiyatlar.Cocuk.fiyat += oda.Cocuk1 * satisFiyatlar.CocukFiyati;
        fiyatlar.Bebek.sayi += oda.Cocuk2;
        fiyatlar.Bebek.fiyat += oda.Cocuk2 * satisFiyatlar.BebekFiyati;
      })
      this.eklenenEkHizmetler.forEach(hizmet => {
        fiyatlar.EkHizmetler.sayi += 1;
        fiyatlar.EkHizmetler.fiyat += hizmet.hizmet.Fiyat;
      })
      this.fiyatlar = fiyatlar;
    },
    kisileriKaydet(){
      var kontrol = true;
      this.SelectedOdaTipleri.forEach(oda => {
        if(oda.formlar.yetiskin.some(x => !x.valid)){
          this.snackbar = true,
          this.text1 = "Lütfen Gerekli Yerleri Doldurunuz."
          kontrol = false;
        }
        if(oda.formlar.cocuk.some(x => !x.valid)){
          this.snackbar = true,
          this.text1 = "Lütfen Gerekli Yerleri Doldurunuz."
          kontrol = false;
        }
        if(oda.formlar.bebek.some(x => !x.valid)){
          this.snackbar = true,
          this.text1 = "Lütfen Gerekli Yerleri Doldurunuz."
          kontrol = false;
        }
      });
      if(!kontrol)
        return;
      this.kisiler = [];
      this.SelectedOdaTipleri.forEach(oda => {
        oda.formlar.yetiskin.forEach(kisi => {
          this.kisiler.push(kisi);
        })
        oda.formlar.cocuk.forEach(kisi => {
          this.kisiler.push(kisi);
        })
        oda.formlar.bebek.forEach(kisi => {
          this.kisiler.push(kisi);
        })
      });
      this.e1 = 2;
    },
    updateEklenenEkHizmetler(newHizmetler) {
      this.eklenenEkHizmetler = newHizmetler;
    },
    updateOdemeData(odemeData) {
      this.odemeData = odemeData;
    },
    updateOdalar(odalar){
      this.SelectedOdaTipleri = odalar;
    },
    voucherDownload(){
      var params = {
        pNR_No:this.pnr
      };
      let credentials = JSON.parse(window.localStorage.getItem('credentials'));

      this.$http
        .post(auth.API_URL + "api/Coper/PaketTurVoucher", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
            'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        'MuhasebeSirketNo': credentials.MuhasebeSirketNo.toString(),
          },
          responseType: "arraybuffer"
        }).then((response) => {
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/pdf'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "Voucher.pdf";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
    }
  }
}
</script>